import React from "react";
import styles from "./ActionMenuButton.module.scss";
type OwnProps = {
  onClick?: () => void;
  id?: string;
  children?: JSX.Element;
  disabled?: boolean;
};

const ActionMenuButton = (props: OwnProps): JSX.Element => {
  const classes = props.disabled
    ? [styles.ActionMenuButton, styles.Disabled].join(" ")
    : styles.ActionMenuButton;
  return (
    <div className={classes}>
      <button id={props.id} onClick={props.onClick} disabled={props.disabled}>
        {props.children}
      </button>
    </div>
  );
};

export default ActionMenuButton;
